<template>
  <div>
    <div v-show="selectedComponent === ''">
      <div class="am-header am-main-top-box">
        <div class="am-title am-main-top-box-title">Finance</div>
        <div class="am-header-icons">
          <a v-if="view === 0" @click="active(row)" title="List Active"><svg-icon icon="unhide" class="am-glyphicon-white am-glyphicon-medium" title="List Active"></svg-icon></a>
          <a v-else-if="view === 1" @click="hidden(row)" title="List Hidden"><svg-icon icon="hide" class="am-glyphicon-medium am-glyphicon-white" title="List Hidden"></svg-icon></a>
          <a href="#" @click="firstVideo()"><svg-icon icon="video" title="Create an Integrated Premium Finance Contract" class="am-glyphicon-medium am-glyphicon-white"></svg-icon></a>
          <a href="#" @click="secondVideo()"><svg-icon icon="video" title="Create a Manual Premium Finance Contract" class="am-glyphicon-medium am-glyphicon-white"></svg-icon></a>
          <a href="#" @click="thirdVideo()"><svg-icon icon="video" title="Edit and View Premium Finance Contracts" class="am-glyphicon-medium am-glyphicon-white"></svg-icon></a>
        </div>
      </div>
      <div class="am-main-finance-table" >
        <table class="am-finance-table">
          <thead>
          <tr>
            <th class="text-center">V</th>
            <th class="text-center">E</th>
            <th class="text-center">V</th>
            <th class="text-center">H</th>
            <th class="text-center">AT</th>
            <th class="am-text-align-left" @click="sort('contractNumber')">Contract #<span><img v-if="sortData.currentSort === 'contractNumber'" :src="sorterArrow"></span></th>
            <th class="am-text-align-left" @click="sort('contractStatus')">Status<span><img v-if="sortData.currentSort === 'contractStatus'" :src="sorterArrow"></span></th>
            <th class="am-text-align-left" @click="sort('company.name')">Company<span><img v-if="sortData.currentSort === 'company.name'" :src="sorterArrow"></span></th>
            <th class="am-text-align-left" @click="sort('dateFinanced')">Date<span><img v-if="sortData.currentSort === 'dateFinanced'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('APR')">APR<span><img v-if="sortData.currentSort === 'APR'" :src="sorterArrow"></span></th>
            <th class="am-text-align-left am-custom-padding-left" @click="sort('numberPayments')">Payments<span><img v-if="sortData.currentSort === 'numberPayments'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('premium')">Premium<span><img v-if="sortData.currentSort === 'premium'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('policyFee')">Policy Fee<span><img v-if="sortData.currentSort === 'policyFee'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('tax')">Tax<span><img v-if="sortData.currentSort === 'tax'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('mgaFee')">MGA Fee<span><img v-if="sortData.currentSort === 'mgaFee'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('total')">Total<span><img v-if="sortData.currentSort === 'totalAmount'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right" @click="sort('amountFinanced')">Amount Financed<span><img v-if="sortData.currentSort === 'amountFinanced'" :src="sorterArrow"></span></th>
            <th class="am-text-align-right am-custom-padding-right" @click="sort('balance','currency')">Balance<span><img v-if="sortData.currentSort === 'balance'" :src="sorterArrow"></span></th>
            <th>Re-Quote</th>
            <th>Attachments</th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td v-if="dataByActiveValue.length === 0" class="center no_records_found" colspan="20">
               No Finance Contracts found
            </td>
          </tr>
          <tr v-for="(row, index) in premiumFinanceList" v-if="row.active === view">
            <td class="text-center am-cursor">
              <a title="View" @click="viewFinanceScreen(row)"><svg-icon icon="view" class="am-glyphicon-medium am-glyphicon-blue" title="View"/></a>
            </td>
            <td class="text-center">
              <a v-if="row.contractStatus !== 'Voided'" title="Edit" @click="edit(row)"><svg-icon icon="edit" class="am-glyphicon-medium am-glyphicon-blue" title="Edit"></svg-icon></a>
              <div v-else></div>
            </td>
            <td class="text-center">
              <a v-if="row.contractStatus === 'Approved' && hasPermission('PRreceiptvoid')" title="Void" @click="showVoidContract(row.id, row.receipt_details)"><svg-icon icon="void" class="am-glyphicon-medium am-glyphicon-blue" title="Void"></svg-icon></a>
              <a v-else-if="row.contractStatus === 'Quoted' && hasPermission('PRreceiptvoid')" title="Void"><svg-icon icon="void" class="am-glyphicon-medium am-glyphicon-gray am-cursor-default" title="Void"></svg-icon></a>
              <div v-else></div>
            </td>
            <td class="text-center" v-if="view === 0">
              <a title="Show" v-bind:id=row.id  @click="showHideModal(row)"><svg-icon icon="unhide" title="show" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a></td>
            <td class="text-center" v-if="view === 1">
              <a title="Hide" v-bind:id=row.id  @click="showHideModal(row)"><svg-icon icon="hide" title="Hide" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a></td>
            <td class="text-center">
              <a @click="attachment(row)" title="Add Attachment"><svg-icon icon="import" title="Import" class="am-glyphicon-medium am-glyphicon-blue"></svg-icon></a>
            </td>
            <td class="am-text-align-left">{{row.contractNumber}}</td>
            <td class="am-text-align-left" :class="{'am-negative-amount': row.contractStatus === 'Voided' }">{{row.contractStatus}}</td>
            <td class="am-text-align-left"><a :href="row.company.website" target="_blank">{{row.company.name}}</a></td>
            <td class="am-text-align-left">{{row.dateFinanced | moment("MM/DD/YYYY") }}</td>
            <td class="am-text-align-right">{{getAprPayments(row).apr}}</td>
            <td class="am-text-align-left am-custom-padding-left">{{getAprPayments(row).numberOfPayments}}</td>
            <td class="am-text-align-right">{{formatCurrency(row.premium)}}</td>
            <td class="am-text-align-right">{{formatCurrency(row.policyFee)}}</td>
            <td class="am-text-align-right">{{formatCurrency(row.tax)}}</td>
            <td class="am-text-align-right">{{formatCurrency(row.mgaFee)}}</td>
            <td class="am-text-align-right">{{formatCurrency(row.total)}}</td>
            <td class="am-text-align-right">{{formatCurrency(row.amountFinanced)}}</td>
            <td :class="{'am-negative-amount': row.balance < 0 }" class="am-text-align-right am-custom-padding-right">{{formatCurrency(row.balance)}}</td>
            <td><a class="am-pointer" v-if="checkReQuote(row)" href='' @click="requote(row)">Re-Quote</a></td>
            <td><span v-if="row.uploaded_images.length > 0" class="text-center glyphicon glyphicon-paperclip" title="Attachments"></span></td>
          </tr>
          </tbody>
        </table>
        <div class="am-pagination" v-show="dataByActiveValue.length > pageSize">
          <pagination :allData="dataByActiveValue" :pageSize="pageSize" :sortData="sortData" @setPageData="setPageData"></pagination>
        </div>
      </div>
      <div class="am-bottom-ribbon am-main-bottom-box"></div>
    </div>
    <div>
      <component :is="selectedComponent" :edit-row="editRow" :isViewScreen="isViewScreen" v-bind="componentProps" @changeComponent="changeComponent" @viewFinanceScreen="viewFinanceScreen" @refreshList="refreshList" @toggleAttachment="toggleAttachment"></component>
    </div>
    <modal name="PremiumFinanceHide" classes="am-vue-modal" :clickToClose="false" :pivotY="0.3" height="150px" width="400px">
      <hide-confirmation :index="hideModalData.id" :active="hideModalData.active" name="Contract?" @toggleAction="toggleHide" @closeAction="closeHideModal"></hide-confirmation>
    </modal>
    <modal name="PremiumFinanceVoid" classes="am-vue-modal" :clickToClose="false" height="150px" width="400px" :pivotY="0.3">
      <finance-void-contract :id="voidContractId" :customer-id="customerId" :canVoid="canVoidContract" @closeAction="closeVoidContract"></finance-void-contract>
    </modal>
    <play-video v-show="showVideoModal" :videoCode="videoCode" :videoType="videoType"></play-video>
  </div>
</template>

<script>
import api from './../http'
import FinanceViewScreen from './FinanceViewScreen'
import HideConfirmation from './HideConfirmation.vue'
import FinanceEdit from './Finance/FinanceEdit'
import MessagePopup from './MessagePopup'
import Attachment from './Attachment'
import PlayVideo from './PlayVideo.vue'
import FinanceVoidContract from "./FinanceVoidContract";
import helper from '@/mixins/helper'
import sort from '@/mixins/tableSorter'
import pagination from '@/components/pagination/pagination.vue'
export default {
  name: 'FinanceTab',
  data () {
    return {
      selectedComponent: '',
      hideModalData: {},
      voidContractId: 0,
      canVoidContract: 0,
      premiumFinance: {},
      quoteContract: {},
      view: 1,
      editRow: {},
      showVideoModal: false,
      videoCode: '399969419',
      videoType: 'vimeo',
      componentProps: {},
      isViewScreen: false,
      confirmation: 'Alert',
      deleteContractId: 0,
      jumpToViewScreen: true,
      pageSize: 15,
      premiumFinanceList: [],
      addForm: {
        'contractNumber': '',
        'agreementID': '',
        'memo': '',
        'paidToAgency': 0,
        'customerID': this.customerId,
        'contractStatus': 'Quoted',
        'compID': this.financeCompanyId,
        'premium': 0,
        'policyFee': 0,
        'mgaFee': 0,
        'tax': 0,
        'downPayment': 0
      }
    }
  },
  mixins: [helper, sort],
  components: {
    FinanceVoidContract,
    FinanceViewScreen,
    FinanceEdit,
    'hideConfirmation': HideConfirmation,
      MessagePopup,
    Attachment,
    PlayVideo,
    pagination
  },
  computed: {
    dataByActiveValue() {
      let view = this.view
      if (!this.premiumFinance){
        return [];
      }
      return this.premiumFinance.filter(row => row.active === view)
    }
  },
  asyncComputed: {
    premiumFinance: {
      get () {
        let self = this;
        return api.makeRequest('/finance/' + this.customerId + '/contracts').then(
          (data) => {
            let id = self.componentProps.financeId ? self.componentProps.financeId : typeof self.financeId !== 'undefined' ? self.financeId : 0
            if(id && self.jumpToViewScreen) {
              self.viewFinanceScreen(data.data.premiumFinance.find(contract => contract.id === id))
            }
            else if(self.financeForm === 'add') {
              self.addForm.premium = this.financeDetails.premium
              self.addForm.policyFee = this.financeDetails.policyFee
              self.addForm.mgaFee = this.financeDetails.mgaFee
              self.addForm.tax = this.financeDetails.tax
              self.addForm.policyIds = self.policyIds.split(',')

              self.financeForm = ''
              self.edit(self.addForm)
            }
            self.jumpToViewScreen = false
            return data.data.premiumFinance
          }
        )
      },
      default: []
    }
  },
  methods: {
    setPageData (data) {
      this.premiumFinanceList = data
    },

    firstVideo: function () {
      this.showVideoModal = true
      this.videoCode = '410775288'
      this.$modal.show('playVideo')
    },

    secondVideo: function () {
      this.showVideoModal = true
      this.videoCode = '399969419'
      this.$modal.show('playVideo')
    },

    thirdVideo: function () {
      this.showVideoModal = true
      this.videoCode = '399958432'
      this.$modal.show('playVideo')
    },
    showVoidContract (id, receipts) {
      this.voidContractId = id
      this.canVoidContract = (typeof receipts === 'undefined' || receipts.length === 0) ? 1 : 0
      this.$modal.show('PremiumFinanceVoid')
    },
    closeVoidContract() {
      this.$modal.hide('PremiumFinanceVoid')
      this.refreshList()
    },
    getAprPayments (row) {
      let data = {
        'apr': '',
        'numberOfPayments': ''
      }
      switch(row.company.premiumfinancesystem) {
        case 'Finance Master':
          if(row.contractStatus === 'Approved') {
            data.apr = row.APR + '%'
            data.numberOfPayments = row.numberPayments
          }
          break
        default:
          data.apr = row.APR + '%'
          data.numberOfPayments = row.numberPayments
      }
      return data
    },

      refreshList(jumpToViewScreen = false) {
          this.jumpToViewScreen = jumpToViewScreen
          this.$asyncComputed.premiumFinance.update()
      },

      edit(row) {
        this.editRow = row
        this.selectedComponent = 'FinanceEdit'
      },
      attachment(row) {
        this.componentProps = { id: row.id, header: 'Finance', tableName: 'premiumFinance', attachmentType: 'isPremiumFinance', customerId: row.customerID}
        this.selectedComponent = 'Attachment'
      },
      show() {
        this.hideModalData.active = 1
        return api.putRequest('/finance/' + this.hideModalData.id + '/unhide', '')
      },
      hide: function () {
        this.hideModalData.active = 0
        return api.putRequest('/finance/' + this.hideModalData.id + '/hide', '')
      },
      showHideModal(row) {
        this.hideModalData = row
        this.$modal.show('PremiumFinanceHide')
      },
      toggleHide () {
        if (this.hideModalData.active) {
            this.hide()
        } else {
            this.show()
        }
        this.closeHideModal()
      },
      closeHideModal() {
        this.$modal.hide('PremiumFinanceHide')
      },
      hidden() {
        this.view = 0
      },
      active() {
        this.view = 1
      },
      changeComponent(name, id) {
          if (name === 'FinanceEdit') {
              this.editRow = this.premiumFinance.find(function (finance) {
                  return finance.id == id
              })
              this.isViewScreen = true
          } else {
              this.isViewScreen = false
          }
          this.selectedComponent = name
      },
      viewFinanceScreen (record) {
        this.componentProps = { financeId: record.id, customerId: record.customerID, financeRecord: record }
        this.selectedComponent = 'FinanceViewScreen'
    },
    toggleAttachment () {
      this.refreshList()
      this.selectedComponent = ''
    },
    requote (row) {
      this.quoteContract.policyIds = this.getPolicyIds(row)
      this.quoteContract.policyMinDate = this.getPolicyMinDate(row)
      this.quoteContract.insuranceType = row.policy[0].product.policy_type.line_of_business.type
      this.$store.dispatch('events/fireEvent', { name: 'open-finance-contract', data: "insuranceType="+ this.quoteContract.insuranceType +"&policyIds="+ this.quoteContract.policyIds + "&transactionType=policy&requote=1&policyMinDate=" + this.quoteContract.policyMinDate  })

    },
    getPolicyIds(row) {
      let ids = '';
      row.policy.forEach(policyId => {
        ids = policyId.id + ',' + ids
      })
      return ids.slice(0,ids.length-1);
    },
    getPolicyMinDate(row) {
      let policyEffDates = []
      row.policy.forEach(policy => {
        policyEffDates.push(moment(policy.effdate, "YYYY-MM-DD"))
      })

      return moment.min(policyEffDates).format("YYYY-MM-DD")
    },
    checkReQuote(financeRecord){
      let isIntegrated = financeRecord.company.finance_company_details !== null ? financeRecord.company.finance_company_details.isIntegrated : 0
      return (financeRecord.contractStatus === 'Quoted' && financeRecord.company.premiumfinancesystem === 'Finance Master' && isIntegrated) ? 1 : 0
    }
  },
  props: {
    customerId: Number,
    financeId: Number,
    financeForm: String,
    policyIds: String,
    financeCompanyId: Number,
    financeDetails: Object
  }
}
</script>

<style>
  .am-header {
    height: 35px;
  }

  .am-title {
    font-size: 14px;
    font-weight: bold;
    float: left;
    padding: 8px 8px 8px 15px;
  }

  .am-header-icons {
    padding: 6px 15px;
    float: right;
  }

  .am-header-icons a {
    padding-right: 5px;
  }

  .am-pointer {
    cursor: pointer;
  }

  .am-cursor-default {
    cursor: default;
  }

  .am-bottom-ribbon {
    height: 35px;
  }

  .am-main-finance-table {
    padding: 15px 15px 0 15px;
  }

  .am-finance-table {
    width: 1300px;
  }

  .am-finance-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-finance-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-finance-table thead {
    background-color: #444444;
    color: white;
  }

  .am-finance-table thead tr {
    height: 20px;
  }

  .am-finance-table th {
    font-size: 11px;
    cursor: pointer;
  }

  .am-finance-table td {
    font-size: 11px;
  }

  .am-text-align-left {
    text-align: left;
  }

  .am-text-align-right {
    text-align: right;
  }

  .am-custom-padding-left {
    padding-left: 10px;
  }

  .am-custom-padding-right {
    padding-right: 15px;
  }

  .am-negative-amount {
    color: red;
  }

  .am-pagination {
    padding: 10px;
    text-align: right;
  }
</style>

<style>
  .am-vue-modal {
    background-color: white;
    text-align: left;
    border-radius: 0;
    box-shadow: 0 20px 60px -2px rgba(27, 33, 58, 0.4);
    padding: 0;
  }
  .v--modal-overlay {
    background-color: rgba(0,0,0,0.6) !important ;

  }
</style>
